<template>
    <div>
        <div v-if="options_loaded && passed_filter"  class="designeroption" :data-designer-component-id="component_id">
            <h3 v-if="title">{{ title }}</h3>
            <div class="stylesoption">
                <a href="!#" @click.prevent="showModal()">
                    <div class="colour-selector-box" :style="rgbStyleFor(target)">
                        <img :src="'/images/cog.png'">
                    </div>
                    <span>{{ labelFor(target) }}</span>
                </a>
            </div>
        </div>
        <div :id="htmlId" class="modal-window _lg" tabindex="-1">
            <div class="modal-window-inner">
                <div class="modal-header">
                    <button type="button" class="close" data-modal-hide><i class="far fa-times"></i></button>
                    <h1 class="modal-title"> Choose an {{ title }}</h1>
                </div>
                <div class="modal-content">
                    <ul id='colour-picker-container'>
                        <li v-for="option in filtered_option_list" :class="['swatch', target === option.value ? 'selected' : '']"
                            :value='option.value'
                            :style='rgbStyleFor(option.value)'
                            :data-designer-help-text='option.label'
                            @click="target = option.value"
                            data-modal-hide
                        ></li>
                    </ul>
                    <div class="clearfix"></div>
                </div>
                <div class="modal-footer align-right">
                    <button type="button" class="btn-default" data-modal-hide>Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";
    import DesignerQuestionDoorColourInternal from "./DesignerQuestionDoorColourInternal.vue";

    export default {
        mixins: [
            DesignerQuestionDoorColourInternal,
            Question,
        ],
        data(){
            return {
                htmlId: this.component_id + '-modal',
            }
        },
        props: {
            title: {
                default(){
                    return 'Internal Colour';
                }
            }
        },
        methods: {
            showModal() {
                modal_window.show_modal('#' + this.htmlId);
            },
            rgbStyleFor(value) {
                let option_key = Object.keys(this.filtered_option_list).find(key => this.filtered_option_list[key]['value'] === value);
                let option_rgb = this.filtered_option_list[option_key].rgb;
                if (!option_rgb) {
                    return 'background-color:rgb(255, 255, 255)';
                }
                return 'background-color:rgb(' + option_rgb.r + ',' + option_rgb.g + ',' + option_rgb.b + ')';
            },
            labelFor(value) {
                let option_key = Object.keys(this.filtered_option_list).find(key => this.filtered_option_list[key]['value'] === value);
                return this.filtered_option_list[option_key].label;
            },
        },
    }
</script>
